import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});



instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("pukkatokenDetails");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("pukkatokenDetails");
      window.location.replace("/login");
    }
    return Promise.reject(error);
  }
);

export default instance;
